import { SearchProduct } from '@italist/grpc-proto/entities/search_pb';
import { SocialMetadataFactory } from '../../../components/PageSpecificMetadata/SocialMetadata';
import { getCloudProductImage } from '../../../server/helpers/cloudImage';

const imagePreset = 'mini';

export const productListSocialMetadataFactory = ({
  searchResults,
}: {
  searchResults: SearchProduct.AsObject[];
}): ReturnType<typeof SocialMetadataFactory> => {
  const images = [];
  searchResults.forEach(product => {
    const { imagesList } = product;
    if (imagesList.length > 0) {
      images.push({ url: getCloudProductImage(imagesList[0], imagePreset) });
    }
  });

  return SocialMetadataFactory({
    overrideImages: images,
  });
};
